import { useLanguage } from "@/contexts/LanguageContext";
import {
  Building2,
  BedDouble,
  UtensilsCrossed,
  KeyRound,
  Laptop2,
  Tv2,
  Briefcase,
} from "lucide-react";

const PERSONAS = [
  { key: "villa", Icon: Building2 },
  { key: "airbnb", Icon: BedDouble },
  { key: "restaurant", Icon: UtensilsCrossed },
  { key: "realestate", Icon: KeyRound },
  { key: "nomad", Icon: Laptop2 },
  { key: "streamer", Icon: Tv2 },
  { key: "entrepreneur", Icon: Briefcase },
];

const CustomerTypes = () => {
  const { t } = useLanguage();
  return (
    <section
      id="customers"
      data-testid="customers-section"
      className="bg-[#f7f2ea] py-24 lg:py-32"
    >
      <div className="container-px mx-auto max-w-7xl">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.22em] text-sky-700 font-medium">
            {t("customers.eyebrow")}
          </p>
          <h2 className="font-display mt-3 text-4xl lg:text-6xl font-light tracking-tighter text-neutral-950 text-balance">
            {t("customers.title")}
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
          {PERSONAS.map(({ key, Icon }, i) => (
            <div
              key={key}
              data-testid={`customer-${key}`}
              className="group rounded-3xl bg-white border border-neutral-200 p-5 sm:p-6 hover:bg-neutral-950 hover:text-white transition-colors overflow-hidden"
            >
              <div className="w-11 h-11 rounded-2xl bg-neutral-100 group-hover:bg-white/10 grid place-items-center transition-colors">
                <Icon className="w-5 h-5" />
              </div>
              <div className="mt-5 font-display text-base sm:text-lg font-medium leading-snug break-words">
                {t(`customers.${key}`)}
              </div>
              <div className="mt-2 text-[10px] sm:text-xs uppercase tracking-[0.18em] text-neutral-400 group-hover:text-sky-300">
                0{i + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerTypes;
